import React from "react";
import {
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


import PersonIcon from "@mui/icons-material/Person";
import SpaIcon from "@mui/icons-material/Spa";
import EventIcon from "@mui/icons-material/Event";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import PaymentIcon from "@mui/icons-material/Payment";
import HomeIcon from "@mui/icons-material/Home";

import { IMAGE_URL } from "network";
import visaLogo from "../assets/images/team-2.jpg";

export default function BookingDetailsModal({ open, onClose, booking }) {
  if (!booking) return null;
  //   const img = IMAGE_URL
  // console.log("User Image URL:", IMAGE_URL + booking.user?.image);





  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "20px",
          width: "960px",
          maxWidth: "95vw",
          background: "linear-gradient(180deg, #fff, #fffafc)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          fontWeight: 700,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 2,
          bgcolor: "white",
          //   borderBottom: "1px solid #f0bcd4",
          color: "white",
        }}
      >
        Booking Overview
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "white",
            color: "black",
            width: 32,
            height: 32,
            borderRadius: "50%",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
        >
          <CloseIcon htmlColor="#000" sx={{ fontSize: 20 }} />
        </IconButton>



      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {/* 🧍 Customer */}
        <ColoredSection
          icon={<PersonIcon sx={{ color: "#c2185b" }} />}
          title="Customer Details"
          bg="#fff0f6"
        >
          <Box display="flex" alignItems="center" gap={2}>
            <img
              src={booking.user?.image ? `${IMAGE_URL}${booking.user?.image}` : visaLogo}
              alt={booking.user?.name}
              crossOrigin="anonymous"
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #f8bbd0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
            <Box>
              <Typography fontWeight={600} color="#c2185b">
                {booking.user?.name}
              </Typography>
              <Typography color="text.secondary">{booking.user?.mobile}</Typography>
              <Typography color="text.secondary">
                {booking.user?.email || "No email"}
              </Typography>
            </Box>
          </Box>
        </ColoredSection>

        {/* 💅 Beautician */}
        <ColoredSection
          icon={<SpaIcon sx={{ color: "#8e24aa" }} />}
          title="Beautician Details"
          bg="#f8eaff"
        >
          {booking.assignedBeautician ? (
            <Box display="flex" alignItems="center" gap={2}>
              <img
                src={`${IMAGE_URL}${booking.assignedBeautician?.image}` || "default-beautician.png"}
                alt={booking.assignedBeautician?.name}
                crossOrigin="anonymous"
                style={{
                  width: 70,
                  height: 70,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid #e1bee7",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
              <Box>
                <Typography fontWeight={600} color="#8e24aa">
                  {booking.assignedBeautician?.name}
                </Typography>
                <Typography color="text.secondary">
                  {booking.assignedBeautician?.mobile}
                </Typography>
              </Box>
            </Box>
          ) : (
            <Typography color="text.secondary">No beautician assigned yet.</Typography>
          )}
        </ColoredSection>

        {/* 🗓️ Booking Info */}
        <ColoredSection
          icon={<EventIcon sx={{ color: "#0288d1" }} />}
          title="Booking Information"
          bg="#e3f2fd"
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field label="Booking Date" value={new Date(booking.bookingDate).toLocaleDateString()} />
            </Grid>
            <Grid item xs={6}>
              <Field label="Time Slot" value={`${booking.startTime} - ${booking.endTime}`} />
            </Grid>
            <Grid item xs={6}>
              <Field
                label="Order Status"
                value={
                  <Chip
                    label={booking.orderStatus || "N/A"}
                    color={
                      booking.orderStatus === "complete"
                        ? "success"
                        : booking.orderStatus === "processing"
                          ? "warning"
                          : "default"
                    }
                    size="small"
                  />
                }
              />
            </Grid>
            <Grid item xs={6}>
              <Field label="Service Status" value={booking.serviceStatus || "-"} />
            </Grid>
          </Grid>
        </ColoredSection>

        {/* 📦 Items */}
        <ColoredSection
          icon={<ShoppingBagIcon sx={{ color: "#6d4c41" }} />}
          title="Items"
          bg="#fff8e1"
        >
          {booking.items?.length ? (
            booking.items.map((item, index) => (
              <Box
                key={index}
                sx={{
                  background: "#fffdf4",
                  p: 1.5,
                  borderRadius: 2,
                  mb: 1,
                  border: "1px solid #f1e4c6",
                }}
              >
                <Typography fontWeight={600}>{item.itemRef?.name}</Typography>
                <Typography color="text.secondary">
                  Quantity: {item.quantity} | Type: {item.itemType}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography color="text.secondary">No items found.</Typography>
          )}
        </ColoredSection>

        {/* 💳 Payment Summary */}
        <ColoredSection
          icon={<PaymentIcon sx={{ color: "#2e7d32" }} />}
          title="Payment & Pricing"
          bg="#e8f5e9"
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field label="Payment Method" value={booking.paymentMethod?.toUpperCase()} />
            </Grid>
            <Grid item xs={6}>
              <Field label="Payment Status" value={booking.paymentStatus} />
            </Grid>
            <Grid item xs={6}>
              <Field label="Total Amount" value={`₹${booking.totalAmount}`} />
            </Grid>
            <Grid item xs={6}>
              <Field label="Discount" value={`₹${booking.discount}`} />
            </Grid>
            <Grid item xs={6}>
              <Field label="Tax" value={`₹${booking.tax}`} />
            </Grid>
            <Grid item xs={6}>
              <Field
                label="Grand Total"
                value={<Typography fontWeight={700} color="#2e7d32">₹{booking.grandTotal}</Typography>}
              />
            </Grid>
          </Grid>
        </ColoredSection>

        {/* 🏠 Address */}
        <ColoredSection icon={<HomeIcon sx={{ color: "#546e7a" }} />} title="Address" bg="#eceff1">
          <Typography>{booking.address?.fullAddress}</Typography>
        </ColoredSection>
      </DialogContent>
    </Dialog>
  );
}

/* 🌸 Helper Components */
const ColoredSection = ({ icon, title, bg, children }) => (
  <Box
    sx={{
      mb: 3,
      p: 2.5,
      borderRadius: 3,
      background: bg,
      boxShadow: "inset 0 0 8px rgba(0,0,0,0.05)",
    }}
  >
    <Box display="flex" alignItems="center" gap={1} mb={1.2}>
      {icon}
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
    </Box>
    <Divider sx={{ mb: 1 }} />
    {children}
  </Box>
);

const Field = ({ label, value }) => (
  <Box>
    <Typography color="text.secondary" sx={{ fontSize: "0.9rem" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: "1rem" }}>{value || "-"}</Typography>
  </Box>
);